/** Übersicht der Geschichten: Ziel nach Anmeldung oder Registrierung, wenn nichts anderes angegeben ist. */
export const APP_HOME = '/app';

/** Seiten, die als Ziel keinen Sinn ergeben (man käme im Kreis). */
const PUBLIC = new Set(['/', '/login', '/register', '/reset']);

/**
 * Ziel nach Anmeldung oder Registrierung aus `?next=…`: nur ein Pfad dieser Seite – keine fremde Adresse (`//host`, `https://…`,
 * `/\\host`), damit der Link niemanden woandershin schicken kann. Sonst die Übersicht.
 */
export function safeNext(next: string | null | undefined): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) return APP_HOME;
  const path = next.split(/[?#]/)[0]!;
  return PUBLIC.has(path) ? APP_HOME : next;
}
